import { Flex } from '@mantine/core'

import classes from '@/modules/dashboard/pages/components/DashboardShell/DashboardShell.module.css'

import { AssetsDebtChart } from '@/components/@Shared/AssetsDebtChart/AssetsDebtChart'
import { AssetsValueChart } from '@/components/@Shared/AssetsValueChart/AssetsValueChart'
import { Budget } from '@/components/@Shared/Budgets/Budgets'
import { DebtValueChart } from '@/components/@Shared/DebtValueChart/DebtValueChart'
import { IncomeSummary } from '@/components/@Shared/IncomeSummary/IncomeSummary'
import { SpendingSummary } from '@/components/@Shared/SpendingSummary/SpendingSummary'
import { GoalsWidget } from '@/components/GoalsWidget/GoalsWidget'

export function Charts({ userId }: { userId: number }) {
  return (
    <>
      <AssetsDebtChart userId={userId} />

      <Flex className={classes.incomeAssetsContainer}>
        <Flex className={classes.donutChartsContainer}>
          <AssetsValueChart userId={userId} />

          <DebtValueChart userId={userId} />
        </Flex>

        <Flex className={classes.summary}>
          <IncomeSummary userId={userId} />

          <SpendingSummary userId={userId} />
        </Flex>
      </Flex>

      <Flex className={classes.budgetActionsContainer}>
        <Budget userId={userId} />
        <GoalsWidget userId={userId} />
      </Flex>
    </>
  )
}
